// extracted by mini-css-extract-plugin
export default {"item":"Alias_item__M8aqS","text":"Alias_text__sIewK"};